'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementBooleanContainer = undefined;

var _arrayDifference = require('d2-utilizr/lib/arrayDifference');

var _arrayDifference2 = _interopRequireDefault(_arrayDifference);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _containerConfig = require('./containerConfig');

var _containerConfig2 = _interopRequireDefault(_containerConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataElementBooleanContainer = exports.DataElementBooleanContainer = undefined;

exports.DataElementBooleanContainer = DataElementBooleanContainer = function DataElementBooleanContainer(refs) {
    var i18n = refs.i18nManager.get();

    Ext.define('Ext.ux.container.DataElementBooleanContainer', {
        extend: 'Ext.container.Container',
        alias: 'widget.dataelementbooleancontainer',
        cls: 'ns-dxselector',
        layout: 'column',
        bodyStyle: 'border:0 none',
        style: 'margin: ' + _containerConfig2.default.margin,
        getRecord: function getRecord() {
            var items = this.valueCmp.getValue(),
                record = {
                dimension: this.dataElement.id,
                name: this.dataElement.name
            };

            // array or object
            for (var i = 0; i < items.length; i++) {
                if ((0, _isObject2.default)(items[i])) {
                    items[i] = items[i].code;
                }
            }

            if (items.length) {
                record.filter = 'IN:' + items.join(';');
            }

            return record;
        },
        setRecord: function setRecord(record) {
            if ((0, _isString2.default)(record.filter) && record.filter.length) {
                var a = record.filter.split(':');
                this.valueCmp.setOptionValues(a[1].split(';'));
            }
        },
        getRecordsByCode: function getRecordsByCode(options, codeArray) {
            var records = [];

            for (var i = 0; i < options.length; i++) {
                for (var j = 0; j < codeArray.length; j++) {
                    if (options[i].code === codeArray[j]) {
                        records.push(options[i]);
                    }
                }
            }

            return records;
        },
        initComponent: function initComponent() {
            var container = this,
                idProperty = 'id',
                nameProperty = 'name';

            this.nameCmp = Ext.create('Ext.form.Label', {
                text: this.dataElement.name,
                flex: 1,
                style: 'padding:' + _containerConfig2.default.namePadding
            });

            this.addCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: 'padding: 0',
                height: 18,
                text: 'Duplicate',
                handler: function handler() {
                    container.duplicateDataElement();
                }
            });

            this.removeCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: _containerConfig2.default.removeCmpStyle,
                height: 18,
                text: 'Remove',
                handler: function handler() {
                    container.removeDataElement();
                }
            });

            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
                valueField: 'id',
                displayField: 'name',
                queryMode: 'local',
                editable: false,
                style: 'margin-bottom:0',
                width: _containerConfig2.default.operatorCmpWidth,
                value: 'IN',
                store: {
                    fields: ['id', 'name'],
                    data: [{ id: 'IN', name: 'One of' }]
                }
            });

            this.getData = function (idArray) {
                var data = [],
                    yes = {},
                    no = {};

                yes[idProperty] = '1';
                yes[nameProperty] = i18n.yes;
                no[idProperty] = '0';
                no[nameProperty] = i18n.no;

                for (var i = 0; i < idArray.length; i++) {
                    if (idArray[i] === '1' || idArray[i] === 1) {
                        data.push(yes);
                    } else if (idArray[i] === '0' || idArray[i] === 0) {
                        data.push(no);
                    }
                }

                return data;
            };

            this.searchStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty],
                data: container.getData(['1', '0'])
            });

            // function
            this.filterSearchStore = function (isLayout) {
                var selected = container.valueCmp.getValue();

                // hack, using internal method to activate dropdown before filtering
                if (isLayout) {
                    container.searchCmp.onTriggerClick();
                    container.searchCmp.collapse();
                }

                // filter
                container.searchStore.clearFilter();

                container.searchStore.filterBy(function (record) {
                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
                });
            };

            this.searchCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                width: _containerConfig2.default.operatorCmpWidth,
                style: 'margin-bottom:0',
                emptyText: 'Select..',
                valueField: idProperty,
                displayField: nameProperty,
                queryMode: 'local',
                listConfig: {
                    minWidth: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth
                },
                store: this.searchStore,
                listeners: {
                    select: function select() {
                        var id = (0, _arrayFrom2.default)(this.getValue())[0];

                        // value
                        if (container.valueStore.findExact(idProperty, id) === -1) {
                            container.valueStore.add(container.searchStore.getAt(container.searchStore.findExact(idProperty, id)).data);
                        }

                        // search
                        this.select([]);

                        // filter
                        container.filterSearchStore();
                    },
                    expand: function expand() {
                        container.filterSearchStore();
                    }
                }
            });

            this.valueStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty],
                listeners: {
                    add: function add() {
                        container.valueCmp.select(this.getRange());
                    },
                    remove: function remove() {
                        container.valueCmp.select(this.getRange());
                    }
                }
            });

            this.valueCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                style: 'margin-bottom:0',
                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.operatorCmpWidth,
                valueField: idProperty,
                displayField: nameProperty,
                emptyText: 'No selected items',
                editable: false,
                hideTrigger: true,
                store: container.valueStore,
                queryMode: 'local',
                listConfig: {
                    minWidth: 266,
                    cls: 'ns-optionselector'
                },
                setOptionValues: function setOptionValues(codeArray) {
                    container.valueStore.removeAll();
                    container.valueStore.loadData(container.getData(codeArray));

                    this.setValue(codeArray);
                    container.filterSearchStore(true);
                    container.searchCmp.blur();
                },
                listeners: {
                    change: function change(cmp, newVal, oldVal) {
                        newVal = (0, _arrayFrom2.default)(newVal);
                        oldVal = (0, _arrayFrom2.default)(oldVal);

                        if (newVal.length < oldVal.length) {
                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
                            container.valueStore.removeAt(container.valueStore.findExact(idProperty, id));
                        }
                    }
                }
            });

            this.items = [{
                xtype: 'container',
                layout: 'hbox',
                width: _containerConfig2.default.nameCmpWidth,
                items: [this.nameCmp,
                //this.addCmp,
                this.removeCmp]
            }, this.operatorCmp, this.searchCmp, this.valueCmp];

            this.self.superclass.initComponent.call(this);
        }
    });
};
//# sourceMappingURL=DataElementBooleanContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ux/DataElementBooleanContainer.js
 ** module id = 171
 ** module chunks = 0 1
 **/